<div class="error">
  <div class="title">
    <h1>{{ 'PAGES.ERROR.AN_ERROR_OCCURRED' | translate }}</h1>
  </div>
</div>
